import React, { useEffect, useState, useMemo } from "react";
import OtpInput from "react-otp-input";
import Slider from "react-slick";
import LoginBackgroundImage from "../assets/image/login-bg.jpg";
import SideLogoImage from "../assets/image/login1.svg";
import AuthSlide1 from "../assets/image/auth-slide-img1.png";
import AuthSlide2 from "../assets/image/auth-slide-img2.png";
import AuthSlide3 from "../assets/image/auth-slide-img3.png";
import AuthSlide4 from "../assets/image/auth-slide-img4.png";
import AuthSlide5 from "../assets/image/auth-slide-img5.png";
import AuthSlide6 from "../assets/image/AuthSlide6.svg";
import AuthSlide7 from "../assets/image/AuthSlide7.svg";
import AuthSlide8 from "../assets/image/AuthSlide8.svg";
import AuthSlide9 from "../assets/image/AuthSlide9.svg";
import { Link, useNavigate } from "react-router-dom";
import { Get, Postdata } from "../utils/api.services";
import { fantasyShareSearch } from "../utils/fantasyNavigation";
import { toast } from "react-toastify";
import HttpService from "../utils/https.services";
import { useDispatch, useSelector } from "react-redux";
import { getUserData } from "../redux/selectors/selector";
import { sliderSettings } from "../utils/common";
import {
  verifyOtp,
  verifyOtpFailure,
  verifyOtpSuccess,
} from "../redux/actions/verifyOTP/verifyOTP.action";
import {
  sendOtpFailure,
  sendOtpRequest,
  sendOtpSuccess,
} from "../redux/actions/sendOTP/sendOTP.action";
import "../style/component/login.css";
import "slick-carousel/slick/slick.css";
import { EVENTS, trackEvent } from "./mixpanel";
import Loader from "./loader/loader";
import { AF_EVENTS, trackAFEvent } from "./appsflyer";
import { initTourStateForUser } from "../utils/tourStorage.js";

const Otp = () => {
  const [mobile_otp, setOtp] = useState("");
  const [remainingTime, setRemainingTime] = useState(59);
  const [isloading, setLoading] = useState(false);
  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const settings = sliderSettings(1);
  const getuser = useSelector(getUserData);
  const memoizedGetUser = useMemo(() => getuser, [getuser]);

  // const FetchConfigData = () => {
  //   Get(HttpService()?.configdata, { params: { api_key: 'otp_expire_minute' } })
  //     .then((response) => {
  //       console.log(53, response)
  //       if (response?.status) {
  //         console.log(response?.data[0], "Configdata-----")
  //         // setconfigdata(Number(response?.data?.[0].value));
  //       } else {
  //         toast.error(response?.message);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  useEffect(() => {
    setOtp(""); // Reset the OTP input field
    setRemainingTime(59); // Restart the timer
    setIsResendEnabled(false); // Disable resend button
  }, []);

  const sentOTP = () => {
    const payload = {
      country_code: memoizedGetUser?.country_code,
      mobile: memoizedGetUser?.mobile,
    };
    setRemainingTime(59);
    dispatch(sendOtpRequest(payload));
    Postdata(HttpService()?.sendotp, payload)
      .then((response) => {
        if (response?.status) {
          toast.success(response?.message);
          dispatch(sendOtpSuccess(response));
        } else {
          toast.error(response?.message);
          dispatch(sendOtpFailure(response?.message));
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
        dispatch(sendOtpFailure(error?.response?.data?.message));
      });
  };

  useEffect(() => {
    let timerInterval;
    if (remainingTime > 0) {
      timerInterval = setInterval(() => {
        setRemainingTime((prevTime) => prevTime - 1);
      }, 1000);
    } else if (remainingTime === 0) {
      setIsResendEnabled(true);
    }

    return () => {
      clearInterval(timerInterval);
    };
  }, [remainingTime]);

  const handleSubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    const payload = {
      country_code: memoizedGetUser?.country_code,
      mobile: memoizedGetUser?.mobile,
      otp: mobile_otp,
    };
    dispatch(verifyOtp(payload));
    Postdata(HttpService()?.verifyOtp, payload)
      .then((response) => {
        if (response?.status) {
          toast.success(response?.message);
          dispatch(verifyOtpSuccess(response));
          setLoading(false);
          const user = response?.data?.user?.[0];
          initTourStateForUser(user?._id, {
            isNewSignup: response?.data?.show_referral_page === true,
            isHome: user?.is_home !== false,
          });
          localStorage.setItem("Token", response?.data?.token);
          trackAFEvent(AF_EVENTS.MP_HOME, {
            section: "navigation",
            action: "navigate_home",
          });
          trackEvent(EVENTS.MP_HOME, {
            section: "navigation",
            action: "navigate_home",
          });
          const searchParams = fantasyShareSearch();
          if(response?.data?.show_referral_page){
            navigate(`/referral${searchParams}`);
          }else if (searchParams) {
            navigate(`/${searchParams}`);
          } else {
            navigate("/home");
          }
        } else {
          toast.error(response?.message);
          dispatch(verifyOtpFailure(response?.message));
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  // useEffect(() => {
  //   FetchConfigData();
  // }, []);

  const handleResend = () => {
    setRemainingTime(59); // Reset timer
    setIsResendEnabled(false); // Hide resend text
    if (sentOTP) sentOTP(); // Call the resend OTP function if provided
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        event.preventDefault(); // Prevents unintended behavior
        document.getElementById("submitButton")?.click(); // Click the button
      }
    };

    document.addEventListener("keydown", handleKeyDown); // Add event listener

    return () => {
      document.removeEventListener("keydown", handleKeyDown); // Cleanup listener
    };
  }, []);

  return (
    <div>
      <Loader showLoader={isloading} />
      <div
        className="auth-page d-flex flex-wrap justify-content-between"
        style={{ backgroundImage: `url(${LoginBackgroundImage})` }}
      >
        <div className="auth-page-wrap" style={{ display: "flex", alignItems: "start" }}>
          <div className="auth-logo">
            <a href="#">
              <img src={SideLogoImage} alt="sideLogoImage" />
            </a>
          </div>
          <h1>Verify Contact Number</h1>
          <h3 className="form-title">
            We’ve sent verification code to your contact number
          </h3>
          <div className="form-wrap auth-form">
            <div className="otp-wrap">
              <div className="otp-fields d-flex justify-content-between">
                <OtpInput
                  value={mobile_otp}
                  onChange={setOtp}
                  numInputs={4}
                  inputType="tel"
                  isInputNum={true}
                  placeholder="0000"
                  shouldAutoFocus={true}
                  inputStyle="otp-field form-control"
                  renderInput={(props) => <input {...props} />}
                />
              </div>

              <div className="otp-resend d-flex justify-content-between">
                {isResendEnabled ? (
                  <div></div>
                ) : (
                  <span>00:{remainingTime}s</span>
                )}
                {isResendEnabled && (
                  <Link onClick={handleResend}>Resend Code</Link>
                )}
              </div>
            </div>
            <div className="form-cta">
              <button
                id="submitButton"
                onClick={handleSubmit}
                className="cta-btn cta-fill cta-lg"
              >
                Verify
              </button>
            </div>
          </div>
        </div>
        <div className="auth-page-slider-wrap">
           <Slider {...settings} className="auth-page-slider">
                        <div className="auth-page-slide">
                            <h2 className="h1">Welcome to Rally Bulls!</h2>
                            <p>
                                Dive into the excitement of stock trading in a risk-free fantasy
                                setting. Let’s begin your journey!
                            </p>
                            <div className="img-wrap">
                                <img src={AuthSlide1} alt="stock" />
                            </div>
                        </div>
                        <div className="auth-page-slide">
                            <h2 className="h1">Fantasy Stock Leagues</h2>
                            <p>
                                Only at Rally Bulls can you experience the thrill of fantasy
                                sports reinvented with stocks as your players!
                            </p>
                            <div className="img-wrap">
                                <img src={AuthSlide2} alt="stock" />
                            </div>
                        </div>
                        {/* <div className="auth-page-slide">
                            <h2 className="h1">Contests and Games</h2>
                            <p>
                                Compete in strategic trading challenges, daily trivia,
                                sweepstakes, and win guaranteed prizes.
                            </p>
                            <div className="img-wrap">
                                <img src={AuthSlide3} alt="stock" />
                            </div>
                        </div> */}
                        <div className="auth-page-slide">
                            <h2 className="h1">Paper Trading</h2>
                            <p>
                                Trade in a risk-free environment using virtual currency to test
                                your strategies and explore AI generated trading portfolios.
                            </p>
                            <div className="img-wrap">
                                <img src={AuthSlide5} alt="stock" />
                            </div>
                        </div>
                        {/* <div className="auth-page-slide">
                            <h2 className="h1">Learnings Management System</h2>
                            <p>
                                Explore trading courses at various levels, take quizzes to test
                                your knowledge, and earn certificates to showcase your
                                expertise.
                            </p>
                            <div className="img-wrap">
                                <img src={AuthSlide4} alt="stock" />
                            </div>
                        </div> */}
                        <div className="auth-page-slide">
                            <h2 className="h1">Toro - AI Companion</h2>
                            <p>
                                Toro is your personalized AI companion for mastering financial
                                strategies and market insights.
                            </p>
                            <div className="img-wrap">
                                <img src={AuthSlide6} alt="stock" />
                            </div>
                        </div>
                        {/* <div className="auth-page-slide">
                            <h2 className="h1">Investment Research</h2>
                            <p>
                                Access in-depth investment research to make informed and
                                confident financial decisions.
                            </p>
                            <div className="img-wrap">
                                <img src={AuthSlide7} alt="stock" />
                            </div>
                        </div>
                        <div className="auth-page-slide">
                            <h2 className="h1">Rally Bulls Shop</h2>
                            <p>
                                Explore the Rally Bulls Shop for exciting gift cards and
                                exclusive promotions to reward yourself.
                            </p>
                            <div className="img-wrap">
                                <img src={AuthSlide8} alt="stock" />
                            </div>
                        </div>
                        <div className="auth-page-slide">
                            <h2 className="h1">Community & Networking</h2>
                            <p>
                                Join a vibrant community to connect, network, and grow with
                                like-minded investors and enthusiasts.
                            </p>
                            <div className="img-wrap">
                                <img src={AuthSlide9} alt="stock" />
                            </div>
                        </div> */}
                    </Slider>
          {/* <Slider {...settings} className="auth-page-slider">
            <div className="auth-page-slide">
              <h2 className="h1">Welcome to Rally Bulls!</h2>
              <p>
                Welcome to Rally Bulls, where you can experience the thrill of
                trading stocks in a risk-free fantasy environment. Let's get
                started!
              </p>
              <div className="img-wrap">
                <img src={AuthSlide2} alt="stock" />
              </div>
            </div>
            <div className="auth-page-slide">
              <h2 className="h1">Stock Fantasy</h2>
              <p>
                Offers the fantasy sports gaming experience, but instead of
                athletes, Rally Bulls uses stocks
              </p>
              <div className="img-wrap">
                <img src={AuthSlide1} alt="stock" />
              </div>
            </div>
            <div className="auth-page-slide">
              <h2 className="h1">Welcome to Rally Bulls!</h2>
              <p>
                Welcome to Rally Bulls, where you can experience the thrill of
                trading stocks in a risk-free fantasy environment. Let's get
                started!
              </p>
              <div className="img-wrap">
                <img src={AuthSlide1} alt="stock" />
              </div>
            </div>
            <div className="auth-page-slide">
              <h2 className="h1">Stock Fantasy</h2>
              <p>
                Offers the fantasy sports gaming experience, but instead of
                athletes, Rally Bulls uses stocks
              </p>
              <div className="img-wrap">
                <img src={AuthSlide2} alt="stock" />
              </div>
            </div>
            <div className="auth-page-slide">
              <h2 className="h1">Welcome to Rally Bulls!</h2>
              <p>
                Welcome to Rally Bulls, where you can experience the thrill of
                trading stocks in a risk-free fantasy environment. Let's get
                started!
              </p>
              <div className="img-wrap">
                <img src={AuthSlide1} alt="stock" />
              </div>
            </div>
          </Slider> */}
        </div>
      </div>
    </div>
  );
};

export default Otp;
